<script lang="ts" setup>
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'

defineOptions({
  name: 'SkeletonFilesSection',
})

</script>

<template>
  <div class="files skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Skeletons/Files/SkeletonFilesSection.scss" />
